import React, { useEffect, useRef, useState } from 'react';
import lottie from 'lottie-web';
import redLoader from 'src/assets/animations/loader-red.json';
import vodafoneLoader from 'src/assets/animations/vodafone-loader.json';
import './loader-animation.scss';

type Loader = 'red-loader' | 'vodafone-loader';

export type Props = {
  height?: string | number;
  width?: string | number;
  loader?: Loader;
};

export default function LoaderAnimation(props: Props) {
  const element = useRef<HTMLDivElement>(null);
  const lottieInstance = useRef<any>();
  const [style, setStyle] = useState({});

  const loaderMap = new Map<Loader, unknown>([
    ['red-loader', redLoader],
    ['vodafone-loader', vodafoneLoader],
  ]);

  useEffect(() => {
    const styleNew = {};

    if (props.width) {
      // @ts-ignore
      styleNew.width = props.width;
    }

    if (props.height) {
      // @ts-ignore
      styleNew.height = props.height;
    }

    const params = {
      loop: true,
      autoplay: true,
      animationData: loaderMap.get(props.loader ?? 'red-loader'),
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
      ...styleNew,
    };

    setStyle(styleNew);

    if (element.current) {
      lottieInstance.current = lottie.loadAnimation({
        ...params,
        container: element.current,
      });
    }
  }, []);

  return <div className="LoaderAnimation" style={style} ref={element} />;
}
